import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewDecoupleAction {
  public static readonly type = '[AllocationViewDecoupleAction] Decouple';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewDecoupleSetInitialState {
  public static readonly type = '[AllocationViewDecoupleAction] Set Initial State';
}
